import { Component } from '@angular/core';

@Component({
    selector: 'app-mostrar-formulario',
    templateUrl: './mostrar-formulario.component.html',
    styleUrls: ['./mostrar-formulario.component.css'],
})
export class MostrarFormularioComponent {}
